 
// src/redux/reducers/jobTypeReducer.js
import {
    FETCH_JOBTYPE_FAILURE,
    FETCH_JOBTYPE_REQUEST,
    FETCH_JOBTYPE_SUCCESS, 
    SET_SELECTED_JOBTYPE 
  } from '../types';
  
  const initialState = {
    loading: false,
    jobTypeList: [],
    selectedJobTypeId: null, 
    error: null,
  };
  
  const jobTypeReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_JOBTYPE_REQUEST:
        return { ...state, loading: true };
      case FETCH_JOBTYPE_SUCCESS:
        return { ...state, loading: false, jobTypeList: action.payload };
      case FETCH_JOBTYPE_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case SET_SELECTED_JOBTYPE:
        return { ...state, selectedJobTypeId: action.payload };
      default:
        return state;
    }
  };
  
  export default jobTypeReducer;
  